import { useContext } from 'react';
import { PlatformAgentContext } from '../../providers/PlatformAgentProvider';

export default function usePlatformAgentState() {
  return useContext(PlatformAgentContext);
}
